import type { DocumentNode } from 'graphql'
import gql from 'graphql-tag'

const loginQuery: DocumentNode = gql`
  mutation Login($email: EmailAddress!, $password: String!, $productName: OutputLoginProductName = Website, $challengeId: String) {
    login(Output_Product_Name: $productName, input: { email: $email, password: $password, challengeId: $challengeId }) {
      ... on loginPayload {
        apiKey
        refreshToken
      }
      ... on clientError {
        description
      }
    }
  }
`

export default loginQuery
